import { TriggerableConfirmationModal } from "components";
import { type IObservable } from "interfaces";
import { useState } from "react";

export interface RemoveUsersConfirmationModalProps {
  onTriggerModalObserver: IObservable<(onConfirm: () => void, ids: number[]) => void>;
  onConfirmed: (ids: number[]) => Promise<void> | void;
}

const RemoveUsersConfirmationModal = ({ onTriggerModalObserver, onConfirmed }: RemoveUsersConfirmationModalProps) => {
  const [ids, setIds] = useState<number[]>([]);
  return (
    <TriggerableConfirmationModal
      title={`Delete User(s)?`}
      confirmButtonLabel="Delete"
      content={"Are you sure you want to delete the selected user(s)?"}
      onTriggerModalObserver={onTriggerModalObserver}
      onConfirmed={() => onConfirmed(ids)}
      onTrigger={(ids: number[]) => {
        setIds(ids);
      }}
    />
  );
};

export default RemoveUsersConfirmationModal;
